import { isListNotEmpty, isObjectNotEmpty, isStringNotEmpty } from "./objectUtils";
import { getEffectiveOfferToken, getLegacyOfferGroup, getOfferGroupById } from "./productIdentityUtils";

const APP_BASE_URL = "https://app.readyrx.com";

export const getEntityOfferToken = (entity, offerGroups = [], products = []) => {
    if (!isObjectNotEmpty(entity)) {
        return null;
    }

    if (isStringNotEmpty(entity.offerToken)) {
        return entity.offerToken;
    }

    if (isStringNotEmpty(entity.offerGroupId)) {
        const offerGroup = getOfferGroupById(entity.offerGroupId, offerGroups);
        if (isObjectNotEmpty(offerGroup) && isStringNotEmpty(offerGroup.offerToken)) {
            return offerGroup.offerToken;
        }
    }

    const matchingProduct = isListNotEmpty(products) && isStringNotEmpty(entity.productSku)
        ? products.find((product) => product.sku === entity.productSku) ?? null
        : null;

    if (isObjectNotEmpty(matchingProduct)) {
        return getEffectiveOfferToken(matchingProduct, offerGroups);
    }

    return getLegacyOfferGroup(entity.productSku)?.offerToken ?? null;
};

export const buildProgramFunnelPath = ({ programSlug = null, offerToken = null, funnelType = 'f' }) => {
    if (!isStringNotEmpty(programSlug)) {
        return null;
    }

    const pathParts = ['', funnelType, programSlug];
    if (isStringNotEmpty(offerToken)) {
        pathParts.push(offerToken);
    }

    return pathParts.join('/');
};

export const buildLeadFunnelPath = ({ programSlug = null, lead = null, offerGroups = [], products = [], funnelType = 'f' }) => {
    const offerToken = getEntityOfferToken(lead, offerGroups, products);
    return buildProgramFunnelPath({
        programSlug,
        offerToken,
        funnelType
    });
};

export const buildLeadResumeQuery = ({ lead = null, repId = null }) => {
    const params = new URLSearchParams();

    if (isStringNotEmpty(lead?.id)) {
        params.set('lid', lead.id);
    }
    if (isStringNotEmpty(lead?.affiliateInfo?.version)) {
        params.set('v', lead.affiliateInfo.version);
    }
    if (isStringNotEmpty(lead?.affiliateInfo?.couponCode)) {
        params.set('coupon', lead.affiliateInfo.couponCode);
    }
    if (isStringNotEmpty(repId)) {
        params.set('repid', repId);
    }


    return params.toString();
};

export const buildLeadFunnelLink = ({ programSlug = null, lead = null, offerGroups = [], products = [], funnelType = 'f', repId = null, baseUrl = APP_BASE_URL }) => {
    const path = buildLeadFunnelPath({ programSlug, lead, offerGroups, products, funnelType });
    if (!isStringNotEmpty(path)) {
        return null;
    }

    const queryString = buildLeadResumeQuery({ lead, repId });
    return `${baseUrl}${path}${isStringNotEmpty(queryString) ? `?${queryString}` : ''}`;
};
